export const TOOLS = {
    LIVING_BENEFIT_RIDERS_CORE: 'lbc',
    LIVING_BENEFIT_RIDERS_PLUS: 'lbc-plus',
    INDEX_COMPARISON_CALCULATOR: 'fia',
    MAKE_A_DIFFERENCE: 'mad',
    INCOME_MODELER: 'imo'
};